export const UPDATE_MIGRATION_ENTITY = 'UPDATE_MIGRATION_ENTITY'

export const CLEAR_MIGRATION_ENTITY = 'CLEAR_MIGRATION_ENTITY'

export const UPDATE_MIGRATIONS_LIST = 'UPDATE_MIGRATION_LIST'

export const SHOW_ALL_THEMIS_MIGRATIONS = 'SHOW_ALL_THEMIS_MIGRATIONS'

export const SHOW_ALL_CPPRO_MIGRATIONS = 'SHOW_ALL_CPPRO_MIGRATIONS'

export const UPDATE_USER = 'UPDATE_USER'

export const SHOW_ALL_SPREADSHEET_MIGRATIONS = 'SHOW_ALL_SPREADSHEET_MIGRATIONS'


// WEBPACK FOOTER //
// ./src/js/action.types.js